module.exports = __webpack_public_path__ + "static/media/logo.b3698f26.svg";